export const countryFormats = {
  RU: { code: '+7', mask: '+7 (###) ###-##-##', icon: 'i-flagpack-ru' },
  KZ: { code: '+7', mask: '+7 (###) ###-####', icon: 'i-flagpack-kz' },
  BY: { code: '+375', mask: '+375 (##) ###-##-##', icon: 'i-flagpack-by' },
  AM: { code: '+374', mask: '+374 ##-###-###', icon: 'i-flagpack-am' },
  KG: { code: '+996', mask: '+996 (###) ###-###', icon: 'i-flagpack-kg' },
  TJ: { code: '+992', mask: '+992 ##-###-####', icon: 'i-flagpack-tj' },
  TM: { code: '+993', mask: '+993 #-###-####', icon: 'i-flagpack-tm' },
  UZ: { code: '+998', mask: '+998 ##-###-####', icon: 'i-flagpack-uz' },
  MD: { code: '+373', mask: '+373 ####-####', icon: 'i-flagpack-md' },
  AZ: { code: '+994', mask: '+994 ##-###-##-##', icon: 'i-flagpack-az' },
  US: { code: '+1', mask: '+1 (###) ###-####', icon: 'i-flagpack-us' },
  GB: { code: '+44', mask: '+44 (####) ###-###', icon: 'i-flagpack-gb' },
}
